const textFieldFormCreateUser = {
  email: 'Email',
  confirmationEmail: 'Confirm Email',
  helperTextEmail: 'The invitation will be sent to this email',
  helperTextConfirmationEmail: 'emails are different'
};

export default textFieldFormCreateUser;
